<template>
  <div
    v-click-outside="hideUserInfo"
    :class="{opened: userInfoOpened}"
    class="info-box">
    <span
      :disabled="!conversationp.contact"
      class="contact-info-toggle-button"
      @click="toggleUserInfo">
      <icon
        v-if="userInfoOpened"
        name="chevron-right"/>
      <icon
        v-else
        name="user"/>
    </span>
    <div
      v-if="!conversationsLoaded || loadingContact"
      class="loader loader-main">
      <div class="loading-circle"/>
    </div>
    <template v-else>
      <ContactInfo
        v-if="conversationExists"
        :contact="contact"/>
      <div
        v-else
        class="no-contact">
        <div class="info">
          <img src="~@/assets/img/no-user-info.svg">
          <h6>
            No contact to show
          </h6>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import ClickOutside from 'v-click-outside';
import ContactInfo from '../contacts/ContactInfo';

export default {
  name: 'UserInfo',
  components: {
    ContactInfo,
  },
  directives: {
    ClickOutside: ClickOutside.directive,
  },
  props: {
    conversationp: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      userInfoOpened: false,
      contact: {
        details_loaded: false,
        address: {
          city: '',
          line: '',
          postal_code: '',
          state: '',
          country: {
            country: '',
            code: '',
          },
        },
        meta_data: {
          country: {
            country: '',
            code: '',
          },
          custom_fields: {},
          notes: [],
        },
        tags: [],
      },
    };
  },
  computed: {
    ...mapGetters({
      loadingContact: 'contact/loadingContact',
      detailedContact: 'contact/contact',
      conversationsLoad: 'chat/conversationsLoad',
    }),
    conversationsLoaded() {
      return this.conversationsLoad.loaded || (this.conversationsLoad.page !== 1);
    },
    conversationExists() {
      return !this.$lodash.isEmpty(this.conversationp);
    },
  },
  watch: {
    conversationp(conversation) {
      if (!this.$lodash.isEmpty(conversation)) {
        if (!conversation.contact.details_loaded) {
          this.fetchContact({
            merchant_id: this.$route.params.merchant_id,
            contact_id: conversation.contact.id,
          });
        } else {
          this.contact = conversation.contact;
        }
      }
    },
    detailedContact(contact) {
      setTimeout(() => {
        this.contact = contact;
        this.contact.details_loaded = true;
        this.$nextTick(() => {
          this.$eventBus.$emit('contactDataChanged', this.contact);
        });
      });
    },
  },
  methods: {
    ...mapActions({
      fetchContact: 'contact/fetchContact',
    }),
    toggleUserInfo() {
      this.userInfoOpened = !this.userInfoOpened;
    },
    hideUserInfo() {
      this.userInfoOpened = false;
    },
  },
};
</script>
